module.exports = __webpack_public_path__ + "img/WhatsApp_Logo.4001a51e.png";